import PropTypes from 'prop-types';

const applyArray = (arr, init) => {
  return arr.reduce((acc, curr, i) => {
    if (curr === null) {
      return acc;
    }

    acc[i] = curr;

    return acc;
  }, init);
};

const updateSpacingDef = (v, def, convNum) => {
  if (Array.isArray(v)) {
    return applyArray(v, def);
  } if (typeof v === 'number') {
    return applyArray(convNum(v), def);
  }

  return def;
};


export const paddingConverter = (theme, props = {}) => {
  const {
    padding,
    paddingHorizontal,
    paddingVertical,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
  } = props;

  let paddingDef = [0, 0, 0, 0];
  paddingDef = updateSpacingDef(padding, paddingDef, (v) => [v, v, v, v]);
  paddingDef = updateSpacingDef(paddingHorizontal, paddingDef, (v) => [null, v, null, v]);
  paddingDef = updateSpacingDef(paddingVertical, paddingDef, (v) => [v, null, v, null]);
  paddingDef = updateSpacingDef(paddingTop, paddingDef, (v) => [v, null, null, null]);
  paddingDef = updateSpacingDef(paddingBottom, paddingDef, (v) => [null, null, v, null]);
  paddingDef = updateSpacingDef(paddingLeft, paddingDef, (v) => [null, null, null, v]);
  paddingDef = updateSpacingDef(paddingRight, paddingDef, (v) => [null, v, null, null]);

  return theme.spacing(...paddingDef);
};

export const paddingDefaultProps = {
  padding: null,
  paddingVertical: null,
  paddingHorizontal: null,
  paddingTop: null,
  paddingBottom: null,
  paddingLeft: null,
  paddingRight: null,
};

export const paddingPropTypes = {
  padding: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  paddingVertical: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  paddingHorizontal: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number,
};
